import useFilterParams from "@/hooks/useFilterParams";
import {
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
  Empty,
} from "@components/ui/empty";
import { Trans } from "@lingui/react/macro";
import { Button } from "@components/ui/button";

export default function FilteredEmpty() {
  const [{ tag }, setFilters] = useFilterParams();

  return (
    <Empty data-testid="filter-no-mentions">
      <EmptyHeader>
        <EmptyMedia></EmptyMedia>
        <EmptyTitle>
          <Trans>Inga omnämnanden</Trans>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>Det finns inga träffar som matchar din sökning.</Trans>
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          variant="outline"
          onClick={(e: unknown) => {
            (e as MouseEvent).preventDefault();
            setFilters({ tag }, true);
          }}
        >
          <Trans>Nollställ filtret</Trans>
        </Button>
      </EmptyContent>
    </Empty>
  );
}
